var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',{staticClass:"mt-0",attrs:{"label":_vm.$t('Disable taxes'),"value":_vm.value.taxes_disabled,"disabled":_vm.loading || _vm.readonly},on:{"input":_vm.updateCartTaxes}})}
var staticRenderFns = []

export { render, staticRenderFns }